import React, { useState, useEffect } from "react";
import "./style.css";

function ScrollTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    const scrollableElement = document.querySelector(".ucarList");
    if (scrollableElement.scrollTop > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    const scrollableElement = document.querySelector(".ucarList");
    scrollableElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const scrollableElement = document.querySelector(".ucarList");
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", toggleVisibility);
      return () =>
        scrollableElement.removeEventListener("scroll", toggleVisibility);
    }
  }, []);

  return (
    <div className='scroll-to-top'>
      {isVisible && (
        <div onClick={scrollToTop}>
          <div className='arrow-up'>↑</div>
        </div>
      )}
    </div>
  );
}

export default ScrollTopButton;
